import React from 'react';
import { translate } from 'react-i18next';

import UnavailablesFullDatePicker from 'components/UnavailablesFullDatePicker.js';
import UnavailablesPartialDatePicker from 'components/UnavailablesPartialDatePicker.js';

class UnavailablesPartialFullDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.setFullDay = this.setFullDay.bind(this);
    this.setPartial = this.setPartial.bind(this);
  }

  setFullDay() {
    this.resetDates(this.props.selectedDate);
    this.props.partialHandler(false);
  }

  setPartial() {
    this.resetDates(null);
    this.props.partialHandler(true);
  }

  resetDates(date) {
    this.props.startsAtHandler(date);
    this.props.endsAtHandler(date);
  }

  datePicker() {
    if (!this.props.partial) {
      return (
        <UnavailablesFullDatePicker
          defaultDate={this.props.selectedDate}
          startsAtHandler={this.props.startsAtHandler}
          endsAtHandler={this.props.endsAtHandler}
        />
      );
    }
    return (
      <UnavailablesPartialDatePicker
        date={this.props.selectedDate}
        startsAt={this.props.startsAt}
        endsAt={this.props.endsAt}
        startsAtHandler={this.props.startsAtHandler}
        endsAtHandler={this.props.endsAtHandler}
        partialHandler={this.props.partialHandler}
      />
    );
  }

  render() {
    return (
      <div>
        <div className="timeoff-partial-full-picker">
          <div>
            <input
              type="radio"
              value="allDay"
              checked={!this.props.partial}
              onChange={this.setFullDay}
            />
            {this.props.t('UnavailablesPartialFullDatePicker.all_day')}
          </div>
          <div>
            <input
              type="radio"
              value="partial"
              checked={this.props.partial}
              onChange={this.setPartial}
            />
            {this.props.t('UnavailablesPartialFullDatePicker.partial_day')}
          </div>
        </div>
        {this.datePicker()}
      </div>
    );
  }
}

export default translate()(UnavailablesPartialFullDatePicker);
